import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import classNames from 'classnames';
import GalleryDisabledIcon from '../../../component/svgs/new/gallery-view-disabled.svg';
import GalleryIcon from '../../../component/svgs/new/gallery-view.svg';

export enum GalleryViewStatus {
  Enabled = 'Enabled',
  Disabled = 'Disabled'
}

export interface GalleryViewProps {
  text: string;
  tipText: string;
  galleryViewStatus: GalleryViewStatus | '';
  icon: string;
  hoverIcon: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const getGalleryViewButtons = (status: GalleryViewStatus | '', isHost: boolean) => {
  if (!isHost) return null;

  if (status === GalleryViewStatus.Disabled) {
    return {
      text: 'Enable',
      tipText: 'Enable Gallery View',
      galleryViewStatus: status,
      icon: 'icon-gallery-view',
      hoverIcon: 'icon-gallery-view-hover'
    };
  } else if (status === GalleryViewStatus.Enabled) {
    return {
      text: 'Disable',
      tipText: 'Disable Gallery View',
      galleryViewStatus: status,
      icon: 'icon-gallery-view-disabled',
      hoverIcon: 'icon-gallery-view-hover'
    };
  }
  return null;
};

const GalleryViewButton = (props: GalleryViewProps) => {
  const { tipText, galleryViewStatus, icon, hoverIcon, onClick, disabled = false } = props;

  return (
    <Tooltip title={tipText}>
      <button
        onClick={onClick}
        disabled={disabled}
        style={{
          ...styles.circleBtn,
          ...(galleryViewStatus === GalleryViewStatus.Enabled ? styles.redBtn : styles.whiteBtn)
        }}
        className="press-effect-btn"
        title={'Virtual background'}
      >
        <img
          src={galleryViewStatus === GalleryViewStatus.Enabled ? GalleryDisabledIcon : GalleryIcon}
          alt="magic"
          style={{
            width: 24,
            height: 24
          }}
        />
      </button>
    </Tooltip>
  );
};

export { GalleryViewButton };

const styles = {
  circleBtn: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    border: 'none'
  },
  whiteBtn: {
    background: '#f0f0f0',
    color: '#1a1a1a'
  },
  redBtn: {
    background: '#C0392B',
    color: '#fff',
    boxShadow: '0 2px 8px rgba(192,57,43,0.4)'
  }
};
